import { css } from 'styled-components';
export const screenReadersOnly = () => css `
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
`;
//# sourceMappingURL=screenReadersOnly.js.map